export function HowItWorks({ copy }) {
  return (
    <section className="px-6 py-10 sm:px-8 lg:px-12 lg:py-14">
      
      <div className="mx-auto max-w-7xl space-y-8">

        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-700">
            {copy.eyebrow}
          </p>

          <h2 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
            {copy.title}
          </h2>

          <p className="mt-4 text-base text-slate-600">
            {copy.description}
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {copy.steps.map((step, index) => (
            <div
              key={step.title}
               className="
                group
                rounded-2xl border border-slate-200 bg-white p-6
                shadow-sm
                transition-all duration-300 ease-out
                hover:shadow-xl hover:-translate-y-1.5
                hover:border-blue-200
              "
            >
              <div className="
                mb-4 flex h-10 w-10 items-center justify-center rounded-full
                bg-blue-600 text-white font-semibold
                transition-all duration-300
                group-hover:scale-110 group-hover:bg-blue-700
              ">
                {index + 1}
              </div>

              <h3 className="text-lg font-semibold text-slate-900">
                {step.title}
              </h3>

              <p className="mt-2 text-sm text-slate-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}